"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setScrollLeft = exports.getScrollLeft = void 0;
var normalize_scroll_left_1 = require("normalize-scroll-left");
var contentDirection = null;
var isRTL = function () { return window.getComputedStyle(document.body, null).getPropertyValue('direction') === 'rtl'; };
var getContentDirection = function () { return (isRTL() ? 'rtl' : 'ltr'); };
var setContentDirection = function () {
    contentDirection = getContentDirection();
};
var getScrollLeft = function (element) {
    return (0, normalize_scroll_left_1.getNormalizedScrollLeft)(element, contentDirection || getContentDirection());
};
exports.getScrollLeft = getScrollLeft;
var setScrollLeft = function (element, value) {
    (0, normalize_scroll_left_1.setNormalizedScrollLeft)(element, value, contentDirection || getContentDirection());
};
exports.setScrollLeft = setScrollLeft;
if (typeof window !== 'undefined') {
    window.addEventListener('load', setContentDirection);
}
var isElement = function (el) { return typeof el === 'object' && el != null && el.nodeType === 1; };
var canOverflow = function (overflow, skipOverflowHiddenElements) {
    if (skipOverflowHiddenElements && overflow === 'hidden') {
        return false;
    }
    return overflow !== 'visible' && overflow !== 'clip';
};
var getFrameElement = function (el) {
    if (!el.ownerDocument || !el.ownerDocument.defaultView) {
        return null;
    }
    try {
        return el.ownerDocument.defaultView.frameElement;
    }
    catch (e) {
        return null;
    }
};
var isHiddenByFrame = function (el) {
    var frame = getFrameElement(el);
    if (!frame) {
        return false;
    }
    return frame.clientHeight < el.scrollHeight || frame.clientWidth < el.scrollWidth;
};
var isScrollable = function (el, skipOverflowHiddenElements) {
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
        var style = getComputedStyle(el, null);
        return (canOverflow(style.overflowY, skipOverflowHiddenElements) ||
            canOverflow(style.overflowX, skipOverflowHiddenElements) ||
            isHiddenByFrame(el));
    }
    return false;
};
/**
 * Find out which edge to align against when logical scroll position is "nearest"
 * Interesting fact: "nearest" works similarily to "if-needed", if the element is fully visible it will not scroll it
 *
 * Legends:
 * ┌────────┐ ┏ ━ ━ ━ ┓
 * │ target │   frame
 * └────────┘ ┗ ━ ━ ━ ┛
 */
var alignNearest = function (scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
    /**
     * If element edge A and element edge B are both outside scrolling box edge A and scrolling box edge B
     *
     *          ┌──┐
     *        ┏━│━━│━┓
     *          │  │
     *        ┃ │  │ ┃        do nothing
     *          │  │
     *        ┗━│━━│━┛
     *          └──┘
     *
     *  If element edge C and element edge D are both outside scrolling box edge C and scrolling box edge D
     *
     *    ┏ ━ ━ ━ ━ ┓
     *   ┌───────────┐
     *   │┃         ┃│        do nothing
     *   └───────────┘
     *    ┗ ━ ━ ━ ━ ┛
     */
    if ((elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd) ||
        (elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd)) {
        return 0;
    }
    /**
     * If element edge A is outside scrolling box edge A and element height is less than scrolling box height
     *
     *          ┌──┐
     *        ┏━│━━│━┓         ┏━┌━━┐━┓
     *          └──┘             │  │
     *  from  ┃      ┃     to  ┃ └──┘ ┃
     *
     *        ┗━ ━━ ━┛         ┗━ ━━ ━┛
     *
     * If element edge B is outside scrolling box edge B and element height is greater than scrolling box height
     *
     *        ┏━ ━━ ━┓         ┏━┌━━┐━┓
     *                           │  │
     *  from  ┃ ┌──┐ ┃     to  ┃ │  │ ┃
     *          │  │             │  │
     *        ┗━│━━│━┛         ┗━│━━│━┛
     *          │  │             └──┘
     *          │  │
     *          └──┘
     *
     * If element edge C is outside scrolling box edge C and element width is less than scrolling box width
     *
     *       from                 to
     *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *  ┌───┐                 ┌───┐
     *  │ ┃ │       ┃         ┃   │     ┃
     *  └───┘                 └───┘
     *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     * If element edge D is outside scrolling box edge D and element width is greater than scrolling box width
     *
     *       from                 to
     *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *        ┌───────────┐   ┌───────────┐
     *    ┃   │     ┃     │   ┃         ┃ │
     *        └───────────┘   └───────────┘
     *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     */
    if ((elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize) ||
        (elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize)) {
        return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
    }
    /**
     * If element edge B is outside scrolling box edge B and element height is less than scrolling box height
     *
     *        ┏━ ━━ ━┓         ┏━ ━━ ━┓
     *
     *  from  ┃      ┃     to  ┃ ┌──┐ ┃
     *          ┌──┐             │  │
     *        ┗━│━━│━┛         ┗━└━━┘━┛
     *          └──┘
     *
     * If element edge A is outside scrolling box edge A and element height is greater than scrolling box height
     *
     *          ┌──┐
     *          │  │
     *          │  │             ┌──┐
     *        ┏━│━━│━┓         ┏━│━━│━┓
     *          │  │             │  │
     *  from  ┃ └──┘ ┃     to  ┃ │  │ ┃
     *                           │  │
     *        ┗━ ━━ ━┛         ┗━└━━┘━┛
     *
     * If element edge C is outside scrolling box edge C and element width is greater than scrolling box width
     *
     *           from                 to
     *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *  ┌───────────┐           ┌───────────┐
     *  │     ┃     │   ┃       │ ┃         ┃
     *  └───────────┘           └───────────┘
     *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     * If element edge D is outside scrolling box edge D and element width is less than scrolling box width
     *
     *           from                 to
     *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *                ┌───┐             ┌───┐
     *        ┃       │ ┃ │       ┃     │   ┃
     *                └───┘             └───┘
     *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     */
    if ((elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize) ||
        (elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize)) {
        return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
    }
    return 0;
};
var getParentElement = function (element) {
    var parent = element.parentElement;
    if (parent == null) {
        return element.getRootNode().host || null;
    }
    return parent;
};
/** @public */
var computeScrollIntoView = function (target, options) {
    var _a, _b, _c, _d, _e, _f;
    if (typeof document === 'undefined') {
        // If there's no DOM we assume it's not in a browser environment
        return [];
    }
    var scrollMode = options.scrollMode, block = options.block, inline = options.inline, boundary = options.boundary, skipOverflowHiddenElements = options.skipOverflowHiddenElements;
    // Allow using a callback to check the boundary
    // The default behavior is to check if the current target matches the boundary element or not
    // If undefined it'll check that target is never undefined (can happen as we recurse up the tree)
    var checkBoundary = typeof boundary === 'function' ? boundary : function (node) { return node !== boundary; };
    if (!isElement(target)) {
        throw new TypeError('Invalid target');
    }
    // Used to handle the top most element that can be scrolled
    var scrollingElement = document.scrollingElement || document.documentElement;
    // Collect all the scrolling boxes, as defined in the spec: https://drafts.csswg.org/cssom-view/#scrolling-box
    var frames = [];
    var cursor = target;
    while (isElement(cursor) && checkBoundary(cursor)) {
        // Move cursor to parent
        cursor = getParentElement(cursor);
        // Stop when we reach the viewport
        if (cursor === scrollingElement) {
            frames.push(cursor);
            break;
        }
        // Skip document.body if it's not the scrollingElement and documentElement isn't independently scrollable
        if (cursor != null && cursor === document.body && isScrollable(cursor) && !isScrollable(document.documentElement)) {
            continue;
        }
        // Now we check if the element is scrollable, this code only runs if the loop haven't already hit the viewport or a custom boundary
        if (cursor != null && isScrollable(cursor, skipOverflowHiddenElements)) {
            frames.push(cursor);
        }
    }
    // Support pinch-zooming properly, making sure elements scroll into the visual viewport
    // Browsers that don't support visualViewport will report the layout viewport dimensions on document.documentElement.clientWidth/Height
    // and viewport dimensions on window.innerWidth/Height
    // https://www.quirksmode.org/mobile/viewports2.html
    // https://bokand.github.io/viewport/index.html
    var viewportWidth = (_b = (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : window.innerWidth;
    var viewportHeight = (_d = (_c = window.visualViewport) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : window.innerHeight;
    // Newer browsers supports scroll[X|Y], page[X|Y]Offset is
    var viewportX = (_e = window.scrollX) !== null && _e !== void 0 ? _e : window.pageXOffset;
    var viewportY = (_f = window.scrollY) !== null && _f !== void 0 ? _f : window.pageYOffset;
    var _g = target.getBoundingClientRect(), targetHeight = _g.height, targetWidth = _g.width, targetTop = _g.top, targetRight = _g.right, targetBottom = _g.bottom, targetLeft = _g.left;
    // These values mutate as we loop through and generate scroll coordinates
    var targetBlock = block === 'start' || block === 'nearest'
        ? targetTop
        : block === 'end'
            ? targetBottom
            : targetTop + targetHeight / 2; // block === 'center
    var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft; // inline === 'start || inline === 'nearest
    // Collect new scroll positions
    var computations = [];
    // In chrome there's no longer a difference between caching the `frames.length` to a var or not, so we don't in this case (size > speed anyways)
    // tslint:disable-next-line:prefer-for-of
    for (var index = 0; index < frames.length; index++) {
        var frame = frames[index];
        var _h = frame.getBoundingClientRect(), height = _h.height, width = _h.width, top_1 = _h.top, right = _h.right, bottom = _h.bottom, left = _h.left;
        // If the element is already visible we can end it here
        if (scrollMode === 'if-needed' &&
            targetTop >= 0 &&
            targetLeft >= 0 &&
            targetBottom <= viewportHeight &&
            targetRight <= viewportWidth &&
            targetTop >= top_1 &&
            targetBottom <= bottom &&
            targetLeft >= left &&
            targetRight <= right) {
            // Break the loop and return the computations for things that are not fully visible
            return computations;
        }
        var frameStyle = getComputedStyle(frame);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        // The property existance checks for offfset[Width|Height] is because only HTMLElement objects have them, but any Element might pass by here
        var scrollbarWidth = 'offsetWidth' in frame
            ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight
            : 0;
        var scrollbarHeight = 'offsetHeight' in frame
            ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom
            : 0;
        var scaleX = 'offsetWidth' in frame
            ? frame.offsetWidth === 0
                ? 0
                : width / frame.offsetWidth
            : 0;
        var scaleY = 'offsetHeight' in frame
            ? frame.offsetHeight === 0
                ? 0
                : height / frame.offsetHeight
            : 0;
        if (scrollingElement === frame) {
            // Handle viewport logic (document.documentElement or document.body)
            if (block === 'start') {
                blockScroll = targetBlock;
            }
            else if (block === 'end') {
                blockScroll = targetBlock - viewportHeight;
            }
            else if (block === 'nearest') {
                blockScroll = alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            }
            else {
                // block === 'center' is the default
                blockScroll = targetBlock - viewportHeight / 2;
            }
            if (inline === 'start') {
                inlineScroll = targetInline;
            }
            else if (inline === 'center') {
                inlineScroll = targetInline - viewportWidth / 2;
            }
            else if (inline === 'end') {
                inlineScroll = targetInline - viewportWidth;
            }
            else {
                // inline === 'nearest' is the default
                inlineScroll = alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            }
            // Apply scroll position offsets and ensure they are within bounds
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        }
        else {
            // Handle each scrolling frame that might exist between the target and the viewport
            if (block === 'start') {
                blockScroll = targetBlock - top_1 - borderTop;
            }
            else if (block === 'end') {
                blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            }
            else if (block === 'nearest') {
                blockScroll = alignNearest(top_1, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            }
            else {
                // block === 'center' is the default
                blockScroll = targetBlock - (top_1 + height / 2) + scrollbarHeight / 2;
            }
            if (inline === 'start') {
                inlineScroll = targetInline - left - borderLeft;
            }
            else if (inline === 'center') {
                inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
            }
            else if (inline === 'end') {
                inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            }
            else {
                // inline === 'nearest' is the default
                inlineScroll = alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            }
            var scrollTop = frame.scrollTop;
            var scrollLeft = (0, exports.getScrollLeft)(frame);
            // Ensure scroll coordinates are not out of bounds while applying scroll offsets
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll / scaleY, frame.scrollHeight - height / scaleY + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll / scaleX, frame.scrollWidth - width / scaleX + scrollbarWidth));
            // Cache the offset so that parent frames can scroll this into view correctly
            targetBlock += scrollTop - blockScroll;
            targetInline += scrollLeft - inlineScroll;
        }
        computations.push({ el: frame, top: blockScroll, left: inlineScroll });
    }
    return computations;
};
exports.default = computeScrollIntoView;
